<template>
  <div class="setting-popup stay-effect" v-if='boxData.judgeBox' :style="{'top': boxData.fix.y+'px', 'left': boxData.fix.x+'px', 'z-index': boxData.Zindex, }" @mousedown="stopDocument($event)">
    <div class="setting-popup__drag-area" v-on:mousedown="moveStart($event, true)" v-on:mousemove="moveArea($event)" v-on:mouseup="saveMoveState($event)" :style="{'cursor': 'move'}">
      特效
    </div>
    <div class="setting-popup__content">
      <div class="effect-type">
        <div v-for="(item, key) in effectSelect">
          <div :class="{active: item.selected, 'effect-select': true}" @click="setEffect($event, item, key)">
            <i class="is-short" :class="{[`icon-${item.type}-anim`]: true}"></i>
          </div>
          <span class="effect-name">{{item.text}}</span>
        </div>
      </div>
    </div>
    <div class="setting-popup__close" @click="close"><i class="icon-popup-close"></i></div>
  </div>
</template>

<script>
import popup from '../mixins/popup'

export default {
  mixins: [popup],
  data () {
    return {
      ANALYSIS: {
        None : {category:'stay_animation_quick_panel', action:'click_empty_animatation', label:'停留动画快捷入口_无动画'},
        path : {category:'stay_animation_quick_panel', action:'click_route_animatation', label:'停留动画快捷入口_路径动画'},
        Whirl : {category:'stay_animation_quick_panel', action:'click_rotate_animatation', label:'停留动画快捷入口_旋转动画'},
        Shake : {category:'stay_animation_quick_panel', action:'click_shake_animatation', label:'停留动画快捷入口_抖动动画'},
      },
      popupType: 'stayEffect',
      type: '',
      effectSelect: [
        {text: '无特效', type: 'None', selected: false},
        {text: '路径动画', type: 'path', selected: false},
        {text: '旋转', type: 'Whirl', selected: false},
        {text: '抖动', type: 'Shake', selected: false},
      ]
    }
  },
  watch: {
    'boxData.judgeBox': function (val) {
      if(val) {
        this.initData()
      }
    }
  },
  methods: {
    initData() {
      if(!this.sprite) return;
      let effect = this.sprite.effect;
      if (effect.pathAnim.end) {
        this.type = 'path';
      } else {
        this.type = effect.stayAnim.type;
      }
      this.effectSelect.forEach((val, k) => {
        val.selected = false;
        val.type === this.type && (val.selected = true);
      })
    },
    setEffect(e, item, key) {
      // if(item.selected) return;
      this[item.type + 'AnimSet'](item.selected);

      this.$bus.emit('updateEffect_vue', {
        sprite: this.sprite,
        effect: this.sprite.effect || {},
        type: 'path'
      });
      this.close();
      this.$analysis(this.ANALYSIS[item.type])
    },
    pathAnimSet(select) {
      if(select) return;
      let start = this.sprite.effect.entranceAnim.end,
          end = start + 2000;
      end > this.sprite.effect.exitAnim.start && (end = this.sprite.effect.exitAnim.start);
      if (end <= start) {
        end = start + 500;
      }
      let { positionTop: y, positionLeft: x, width: w, height: h, rotate } = this.sprite;
      this.sprite.updateEffect({pathAnim: {
        start: start,
        end: end,
        scale: this.sprite.editor.scale,
        target: {
          x: x + 100,
          y: y + 100,
          rotate,
          w: w,
          h: h
        }
      }, stayAnim: {type: 'None'}}, true)

      this.$bus.emit('settingPopup.hideSpriteBtn');
      this.$bus.emit('FeaturesPop_close_vue', { type: 3 })
    },
    WhirlAnimSet () {
      if(this.sprite.effect.stayAnim.type !== 'Whirl') {
        this.sprite.updateEffect({
          pathAnim: null,
          stayAnim: {
            type: 'Whirl',
            position: {
              top: .5,
              left: .5
            },
            speed: 1.05,
            ccw: false
          }
        }, true).then(() =>{
          this.sprite.changeStyle()
        })
      }
      this.$bus.emit('FeaturesPop_vue',{
        type: 1,
        name: 'effectSetting',
        sprite: this.sprite,
        contentType: 'whirl'
      });
    },
    ShakeAnimSet () {
      if(this.sprite.effect.stayAnim.type !== 'Shake') {
        this.sprite.updateEffect({
          pathAnim: null,
          stayAnim: {
            type: 'Shake',
            speed: 2,
            direction: 0,
            amplitude: .25
          }
        }, true).then(() =>{
          this.sprite.changeStyle()
        });
      }
      this.$bus.emit('FeaturesPop_vue',{
         type: 1,
        name: 'effectSetting',
        sprite: this.sprite,
        contentType: 'shake'
      });
    },
    NoneAnimSet () {
      this.sprite.updateEffect({pathAnim: null, stayAnim: {type: 'None'}}, true).then(() =>{
        this.sprite.changeStyle()
      });
    }
  },
 
}
</script>

<style lang="scss" scoped>
.setting-popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 295px;
  z-index: 35;
  border-radius: 6px 6px 3px 3px;
  background: #fff;
  overflow: hidden;
  font-size: 14px;
  box-shadow: 0 0 3px 1px #d8dee9;
  color: #474261;

  &__drag-area {
    line-height: 28px;
    background: #d8dee9;
    text-align: left;
    text-indent: 14px;
  }

  &__content {
    padding: 14px 10px;
    text-align: left;
  }

  &__close {
    position: absolute;
    top: 7px;
    right: 12px;
    height: 14px;
    line-height: 14px;
    width: 14px;
    cursor: pointer;
  }
}

.effect-type{
  display: flex;
  justify-content: space-between;
  align-items: center;

  > div {
    text-align: center;
  }

  .effect-select {
    margin: 0 auto;
    width: 60px;
    height: 60px;
    background-color: #f0f0f8;
    border-radius: 4px;
    margin-bottom: 8px;
    line-height: 68px;
    text-align: center;
    border: 2px solid transparent;
    cursor: pointer;

    &:hover{
      border-color: #627DF2;
    }
  }

  .effect-select.active {
    border-color: #627DF2;
  }

  .icon-None-anim {
    position: relative;
    right: -50%;
    background: red;
    width: 2px;
    height: 102%;
    display: block;
    transform: skew(-45deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/popups/stayEffect.vue